<template lang="pug">
  .post-image(v-if="image" ref="container" :class="{hover : hover}" @mouseleave="hover = false" @mouseover="hover = true" :style="{ width: maxWidth ? `${maxWidth}px` : '100%' }")
    Picture(
      :show-spinner="false"
      :image="image"
      :lazy="true"
      :max-width="624"
      :max-height="624"
      :ignore-container-height="false"
      optimize="speed"
      missing-icon="exclamation-triangle"
      :title="title"
      :style="{ width: maxWidth ? `${maxWidth}px` : '100%' }"
    )
      OverlayImages(:hyperlink="hyperlink" :title="title")
</template>

<script>
import { get, trim } from '@/helpers';
import OverlayImages from '@/sections/Partials/OverlayImages';

export default {
  name: 'PostImage',
  data() {
    return {
      // maxW: undefined,
      // aspectRatio: undefined,
      // w: undefined,
      // h: undefined,
      hover: false
    };
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    maxWidth: {
      type: Number,
      required: false
    }
  },
  components: {
    OverlayImages
  },
  computed: {
    hyperlink() {
      return get(this.content, 'hyperlink') || {};
    },
    title() {
      return get(this.content, 'title');
    },
    text() {
      return get(this.content, 'text');
    },
    image() {
      return get(this.content, 'images.0');
    }
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.content .post-image
  @apply h-full w-full flex
  
  &.hover
    .overlay-title
      @apply flex opacity-100
      bottom: 2rem

  ::v-deep .picture-container
      figure
        @apply w-full h-full
        @screen md
          min-height: 364px
        @screen lg
          min-height: 492px
        @screen xl
          min-height: 620px
        picture
          @apply w-full h-full inline-block
        img
          object-fit: cover
</style>
